import { render, staticRenderFns } from "./property-picker.vue?vue&type=template&id=cb6d5f52&scoped=true&"
import script from "./property-picker.vue?vue&type=script&lang=js&"
export * from "./property-picker.vue?vue&type=script&lang=js&"
import style0 from "./property-picker.vue?vue&type=style&index=0&id=cb6d5f52&prod&scoped=true&lang=css&"
import style1 from "./property-picker.vue?vue&type=style&index=1&id=cb6d5f52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d5f52",
  null
  
)

export default component.exports